"use client";

import { createContext, useContext } from "react";
import { Color, SBrandDto, SearchQuery } from "../../../../__generated__/graphql";
import { CategoryDtoWithHref } from "./SearchSideFilters/types/CategoryDtoWithHref";

export type SiteSearchContextType = {
  items: SearchQuery["search"]["items"] | [];
  sortItems: { value: string; name: string }[];
  categoryNodes: CategoryDtoWithHref[];
  targetCategory: CategoryDtoWithHref | null;
  activeSort?: string;
  isPending?: boolean;
  inStock?: boolean | null;
  hasOffer?: boolean | null;
  colors?: Color[] | null;
  selectedColors?: number[];
  brands?: SBrandDto[] | null;
  selectedBrands?: number[];
  totalProductsCount: number;
  totalPages: number;
  currentPage: number;
  maxInfinitePages: number;
  minPrice?: number | null;
  maxPrice?: number | null;
  search?: string | null;
  selectedTags: string[];
  handleRemoveTag: (tag: string, scroll?: boolean) => void;
  handleSortChange: (newSort: string, scroll?: boolean) => void;
  handleInStockChange: (value: boolean, scroll?: boolean) => void;
  handleHasOfferChange: (value: boolean, scroll?: boolean) => void;
  handleColorsChange: (colors?: number[], scroll?: boolean) => void;
  handleBrandsChange: (brands?: number[], scroll?: boolean) => void;
  handlePageChange: (page: number, scroll?: boolean) => void;
  getPagePath: (page: number) => string;
  handleMinPriceChange: (value?: number | null, scroll?: boolean) => void;
  handleMaxPriceChange: (value?: number | null, scroll?: boolean) => void;
  handlePriceRangeChange: (min?: number | null, max?: number | null, scroll?: boolean) => void;
  handlePriceRangeRemove: (scroll?: boolean) => void;
  handleSearchChange: (input: string, scroll?: boolean) => void;
  endOfListRef: any;
  isFetchingNewPageItems?: boolean;
};

export const SiteSearchContext = createContext<SiteSearchContextType>({
  items: [],
  maxInfinitePages: 5,
  sortItems: [],
  categoryNodes: [],
  targetCategory: null,
  activeSort: undefined,
  inStock: undefined,
  hasOffer: undefined,
  isFetchingNewPageItems: false,
  totalProductsCount: 0,
  totalPages: 0,
  currentPage: 0,
  search: "",
  selectedTags: [],
  handleRemoveTag: () => {},
  colors: [],
  brands: [],
  handleSortChange: () => {},
  handleSearchChange: () => {},
  handleInStockChange: () => {},
  handleColorsChange: () => {},
  handleBrandsChange: () => {},
  handlePageChange: () => {},
  handleHasOfferChange: () => {},
  handleMinPriceChange: () => {},
  handleMaxPriceChange: () => {},
  handlePriceRangeRemove: () => {},
  handlePriceRangeChange: () => {},
  getPagePath: () => "",
  endOfListRef: null,
});

export const useSiteSearchContext = () => useContext(SiteSearchContext);
